import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
//import { map } from 'rxjs/operators';

import { UrlService } from '@core/services/url/url.service';

import { AvailableRuleItem, AvailableRuleEventCondition, RuleEvent, RuleListItem } from '@app/models/rules';
import * as fromRulesModel from '@app/models/rules';

@Injectable({
  providedIn: 'root'
})
export class SettingsRulesRequests {
    private readonly availablePrefix = "/settings/rules";
	private readonly prefix = "/rules";

    constructor(private http: HttpClient, private urlSrv : UrlService) {}

	public loadAvailableEvents$ = () : Observable<fromRulesModel.AvailableRuleEventElement[]> =>
		this.http.get<fromRulesModel.AvailableRuleEventElement[]>(this.urlSrv.build(this.availablePrefix+"/events"));
	
	public loadAvailableConditions$ = (condKey: string) : Observable<fromRulesModel.AvailableRuleConditionVariable[]> =>
		this.http.get<fromRulesModel.AvailableRuleConditionVariable[]>(this.urlSrv.build(this.availablePrefix+"/conditions/"+condKey));
	
	public loadAvailableActions$ = (actionKey: string) : Observable<fromRulesModel.AvailableRuleActionVariable[]> =>
		this.http.get<fromRulesModel.AvailableRuleActionVariable[]>(this.urlSrv.build(this.availablePrefix+"/actions/"+actionKey));
	
	public loadRules$ = () : Observable<RuleListItem[]> =>
		this.http.get<RuleListItem[]>(this.urlSrv.build(this.prefix+"/events"));

	public setActiveRule$ = (ruleId: number, active: boolean) : Observable<any> =>
		this.http.put<any>(this.urlSrv.build(this.prefix+"/events/"+ruleId), {active: active});
	
	public loadRule$ = (ruleId: number) : Observable<RuleEvent> =>
		this.http.get<RuleEvent>(this.urlSrv.build(this.prefix+"/events/"+ruleId));
	
	public updateRule$ = (ruleId: number, rule: RuleEvent) : Observable<RuleEvent> =>
		this.http.put<RuleEvent>(this.urlSrv.build(this.prefix+"/events/" + ruleId ), rule, { headers: new HttpHeaders({ 'Content-Type':  'application/json'}) });

	public createRule$ = (rule: RuleEvent) : Observable<RuleEvent> =>
		this.http.post<RuleEvent>(this.urlSrv.build(this.prefix+"/events"), rule, { headers: new HttpHeaders({ 'Content-Type':  'application/json'}) });

	// public setDeactiveRule = (ruleId: number) : Observable<any> =>
	// 	this.http.delete<any>(this.urlSrv.build(this.prefix+"/events/"+ruleId));
}
